import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { INTENT_KEY, JOIN_CODE_KEY } from "@/pages/Onboarding";

export { JOIN_CODE_KEY };

export default function JoinLink() {
  const { code } = useParams();
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoaded) return;
    localStorage.setItem(JOIN_CODE_KEY, (code || "").toUpperCase());
    localStorage.setItem(INTENT_KEY, "join");
    navigate(isSignedIn ? "/" : "/sign-up", { replace: true });
  }, [code, isLoaded, isSignedIn, navigate]);
  return <p className="muted" style={{ padding: 30 }} data-testid="join-link-redirect">Opening your clinic invite…</p>;
}
